// Allowed upload types (S3DEV2-7865). The server is the real control: keep these in sync with
// Phoenix_Back_End Helper/FileTypePolicy.cs (AllowedExtensions).
export const DOCUMENT_UPLOAD_ACCEPT = [
  ".pdf",
  ".jpg,.jpeg,.png,.gif,.bmp,.tif,.tiff,.webp",
  ".doc,.docx,.xls,.xlsx,.ppt,.pptx,.odt,.ods,.odp",
  ".csv,.txt,.rtf,.mp3"
].join(",");

// Lowercase extension with its dot (".pdf"), or "" when the name has none.
export const getFileExtension = fileName => {
  const name = String(fileName || "");
  const lastDot = name.lastIndexOf(".");
  return lastDot < 0 ? "" : name.slice(lastDot).toLowerCase();
};

// Early, client-side check so a patient is told about an unsupported file right away.
// The server check is the control.
export const isAllowedUploadFile = fileName =>
  DOCUMENT_UPLOAD_ACCEPT.split(",").includes(getFileExtension(fileName));
